import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f75d46a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "messageOverlay",
  class: "message-overlay"
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "message-button-area"
}
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = {
  key: 1,
  class: "message-button-area"
}
const _hoisted_5 = { class: "confirm-button" }
const _hoisted_6 = { class: "cancel-button" }

import { PopupWindow, ButtonItem } from "@/components/modules";
import {
  withDefaults,
  ref,
  watch,
  onMounted,
} from "vue";
import { Message } from "./Message";
import infoIcon from "@/../public/icon/dialog/info.png";
import warningIcon from "@/../public/icon/dialog/warning.png";
import errorIcon from "@/../public/icon/dialog/error.png";
import { windowDialogImportantIndex } from "@/components/modules/popup-window/WindowDialogState";

/**
 * タイトル
 */
interface Props {
  commonView: {
    message: Message;
    multiButtonFlg: boolean;
    confirmCallBack: () => void;
    cancelCallBack: () => void;
  };
  title?: string;
  index: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-dialog',
  props: {
    commonView: {},
    title: {},
    index: {}
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;

const title = ref("");

/**
 * メッセージレベルごとのアイコン
 */
const ICON_PATH_MAP: { [K in Message["level"]]: string } = {
  INFO: infoIcon,
  WARN: warningIcon,
  ERROR: errorIcon,
};

/**
 * メッセージレベルごとのタイトル
 */
const TITLE_MAP: { [K in Message["level"]]: string } = {
  INFO: "メッセージ（情報）",
  WARN: "メッセージ（警告）",
  ERROR: "メッセージ（エラー）",
};





watch(
  () => props.commonView.multiButtonFlg,
  () => {
    if (props.commonView.multiButtonFlg) {
      // 選択肢ボタンがある場合のタイトル
      title.value = "メッセージ（確認）";
    } else {
      // 選択肢ボタンがない場合、メッセージレベルに応じてタイトルを決定
      const level = props.commonView.message.level as Message["level"];
      if (level) {
        title.value = TITLE_MAP[level];
      }
    }
  },
  { immediate: true }
);

/**
 * 決定コールバック実行
 */
const confirm = () => {
  if (props.commonView.confirmCallBack) props.commonView.confirmCallBack();
  emit("close");
};

/**
 * キャンセルコールバック実行
 */
const cancel = () => {
  if (props.commonView.cancelCallBack) props.commonView.cancelCallBack();
  emit("close");
};

/**
 * 初期処理
 */
onMounted(() => {
  document.getElementById("messageOverlay").style.zIndex = (
    windowDialogImportantIndex - 1
  ).toString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_unref(PopupWindow), {
      "data-html2canvas-ignore": "",
      title: title.value,
      width: "450px",
      windowId: "message",
      draggable: false,
      isDisplayBase: true,
      important: true,
      onCloseClick: cancel
    }, {
      "main-content": _withCtx(() => [
        _createElementVNode("div", {
          class: "message-main",
          style: _normalizeStyle({
          backgroundImage: `url(${
            ICON_PATH_MAP[props.commonView.message.level]
          })`,
        })
        }, _toDisplayString(props.commonView.message.message), 5),
        (!props.commonView.multiButtonFlg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(ButtonItem), { onClick: confirm }, {
                  default: _withCtx(() => [
                    _createTextVNode("閉じる")
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(ButtonItem), {
                  class: "confirm-button",
                  onClick: confirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("はい")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(ButtonItem), { onClick: cancel }, {
                  default: _withCtx(() => [
                    _createTextVNode("いいえ")
                  ]),
                  _: 1
                })
              ])
            ]))
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}
}

})